module.exports = __webpack_public_path__ + "img/JOC_3251.039ffa94.jpg";